import { FilterFieldValue } from '../../covance-filter/covance-filter.models';
import { CovanceFilter } from '../../covance-filter/covance-filter';
import { Injectable } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map, refCount, publishReplay, flatMap } from 'rxjs/operators';
import { LabTestResult } from '../../lab-test-results';
import { LabResultsFilterStorage } from './lab-results-filter-storage';
import { ActivatedRoute } from '@angular/router';
import { SponsorLabResultsStorage } from './sponsor-lab-results-storage';
import { routeData } from '../../shared/route-helpers';
import { UnitStorage } from '../../user/unit-storage';
import { SponsorStudySiteIdentity } from '../sites/sponsor-study-site-identity';

@Injectable()
export class SponsorStandardTestResultsStorage {
    public get getData(): Observable<LabTestResult[]> {
        if (!this.testsData) {
            const site$ = this.route.parent.data
                .pipe(
                    map((d) => d[routeData.selectedSiteIdentity] as SponsorStudySiteIdentity),
                );

            const loadData$ = this.sponsorLabResultsStorage.loadLabTestsSiteData(site$);

            const filteredData$ = this.filterDefs
                .pipe(
                    flatMap(filters => {
                        return this.covanceFilter.getFilteredData(loadData$, filters);
                    }));

            this.testsData = combineLatest([filteredData$, this.unitStorage.currentUnit])
                .pipe(
                    map(([results, unit]) => {
                        let result: LabTestResult[] = null;
                        if (results) {
                            result = results.map(r => {
                                r.showResultsInSI = unit.isSiUnit;
                                return r;
                            });
                        }
                        return result;
                    }),
                    publishReplay(1),
                    refCount()
                );
        }

        return this.testsData;
    }

    private testsData: Observable<LabTestResult[]>;

    private filterDefs: Observable<FilterFieldValue[]>;

    constructor(
        private readonly unitStorage: UnitStorage,
        private readonly covanceFilter: CovanceFilter,
        private readonly route: ActivatedRoute,
        private readonly sponsorLabResultsStorage: SponsorLabResultsStorage,
        filterStorage: LabResultsFilterStorage
    ) {
        this.filterDefs = filterStorage.siteDataFilterFields;
    }
}